import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { ReactiveFormsModule } from '@angular/forms'
import { NgOptimizedImage } from '@angular/common'
import { ApiInterceptor } from './helpers/api.interceptor';
import {environment} from "../environments/environment";

import {
  OKTA_CONFIG,
  OktaAuthModule
} from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { AuthInterceptor } from './helpers/auth.interceptor'

const authConfig = {
  issuer: 'https://'+environment.oktaDomain+'/oauth2/'+environment.issuerId,
  clientId: environment.oktaClientId,
  scopes: ['openid', 'email', 'profile', 'groups'],
  redirectUri: window.location.origin + '/'
}
const oktaAuth = new OktaAuth(authConfig);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgOptimizedImage,
    OktaAuthModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    {
      provide: "BASE_API_URL", useValue: environment.apiUrl
    },
    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth }
    },{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
